<template>
  <v-app style = "margin-left: 10px;">
    <v-data-table
      v-model = "selected"
      :headers = "headers"
      :items = "items"
      hide-default-footer>
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cuentas</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <div class="flex-grow-1"></div>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon
          dense
          class="mr-2"
          @click="editItem(item)"
        >
          edit
        </v-icon>
        <v-icon
          dense
          @click="deleteItem(item)"
        >
          delete
        </v-icon>
      </template>
      <template slot="no-data">
        No hay cuentas para administrar
      </template>
    </v-data-table>
    <v-dialog v-model = "dialogRemove" max-width="500">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title>Atención</v-card-title>
        <div v-if = "loading == true">
          <v-card-text>
            Eliminando cuenta...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </div>
        <div v-else>
          <v-card-text>
            ¿Desea eliminar esta cuenta? Esta acción no podrá deshacerse.
          </v-card-text>
          <v-card-actions>
            <div class ="flex-grow-1"></div>
            <v-btn @click = "eliminarCuenta()">Aceptar</v-btn>
            <v-btn @click = "dialogRemove = false">Cancelar</v-btn>
          </v-card-actions>
        </div> 
      </v-card>
    </v-dialog>
    <v-dialog v-model = "dialogMod" max-width = "500">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <v-card-title>Modificar</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols ="10">
              <v-text-field
                v-model = "selectedItem.nombre"
                label = "Nombre"
                required>
              </v-text-field>
            </v-col>
            <v-col cols = "10">
              <v-text-field
                v-model = "selectedItem.email"
                label = "Email"
                :rules = "reglasE"
                required>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class ="flex-grow-1"></div>
          <v-btn @click ="modificarCuenta()" color = "#51D6CC">Aceptar</v-btn>
          <v-btn @click = "dialogMod = false" color = "#51D6CC">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model = "dialogAdd" max-width="500">
      <template v-slot:activator="{ on }">
        <v-btn max-width = "200" v-on="on" style="margin-top: 30px;" color = "#51D6CC">
          <v-icon left dense>fas fa-plus</v-icon> Agregar cuenta
        </v-btn>
      </template>
      <v-card>
        <v-card-title class = "headline">Crear cuenta</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols ="10">
                <v-text-field
                  v-model = "nombre"
                  label = "Nombre"
                  required>
                </v-text-field>
              </v-col>
              <v-col cols = "10">
                <v-text-field
                  v-model = "email"
                  label = "Email"
                  :rules = "reglasE"
                  required>
                </v-text-field>
              </v-col>
              <v-col cols = "10">
                <v-text-field
                  v-model = "email2"
                  label = "Confirme email"
                  :rules = "reglasE"
                  required>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class ="flex-grow-1"></div>
            <v-btn text color="#51D6CC" @click = "crearCuenta()">Aceptar</v-btn>
            <v-btn text color="#51D6CC" @click = "dialogAdd = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model = "warning" max-width="500">
      <template v-slot:activator="{ on }">
      </template>
      <v-card>
        <v-card-title class = "headline">Atención</v-card-title>
        <v-card-text> {{ msgWarning }} </v-card-text>
        <v-card-actions>
          <v-btn text @click = "warning = false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<style scoped>
  .container {
    display: flex;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
</style>
<script>
import axios from 'axios';
import { url } from '@/variables';

export default {
  name: 'Cuentas',
  data() {
    return {
      dialogAdd: false,
      dialogRemove: false,
      dialogMod: false,
      nombre: '',
      email: '',
      email2: '',
      reglasE: [
        v => !!v || 'El email es obligatorio.',
        v => /.+@.+\..+/.test(v) || 'El email debe ser válido.',
      ],
      selected: [],
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Email', value: 'email' },
        {
          text: 'Acciones', value: 'action', sortable: false, width: 5,
        },
      ],
      items: [],
      selectedItem: {},
      loading: false,
      warning: false,
      msgWarning: '',
    };
  },
  methods: {
    init() {
      const path = `${url}/getCuentas`;
      axios.post(path, {
        id: this.$session.get('id'),
        token: this.$session.get('token'),
        codCuenta: this.$session.get('codCuenta'),
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.msg !== 'Ok') {
              this.$session.set('id', '0');
              this.$session.remove('token');
              this.$router.push('/');
            } else this.items = response.data.cuentas;
          }
        });
    },
    crearCuenta() {
      if (this.email === this.email2 && this.email !== '' && this.nombre !== '') {
        const path = `${url}/crearUsuario`;
        axios.post(path, {
          id: this.$session.get('id'),
          token: this.$session.get('token'),
          codCuenta: this.$session.get('codCuenta'),
          mail: this.email,
          nombre: this.nombre,
        })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.msg === 'error email') {
                this.msgWarning = 'Hubo un error enviando el email, por favor reintente más tarde';
              } else
              if (response.data.msg === 'existe usuario') this.msgWarning = 'El mail ingresado ya está asignado a otro usuario.';
              else this.msgWarning = 'La cuenta ha sido creada, se enviará un mail a la dirección de correo ingresada.';
              this.warning = true;
              this.dialogAdd = false;
            }
          });
        this.init();
      }
    },
    eliminarCuenta() {
      this.loading = true;
      const path = `${url}/eliminarUsuario`;
      axios.post(path, {
        id: this.$session.get('id'),
        token: this.$session.get('token'),
        codCuenta: this.$session.get('codCuenta'),
        codigoU: this.selectedItem.codigo,
        mail: this.selectedItem.email,
        nombre: this.selectedItem.nombre,
      })
        .then((response) => {
          if (response.status === 200) {
            this.loading = false;
            this.init();
          }
        });
      this.dialogRemove = false;
    },
    modificarCuenta() {
      const path = `${url}/modificarUsuario`;
      axios.post(path, {
        id: this.$session.get('id'),
        token: this.$session.get('token'),
        codCuenta: this.$session.get('codCuenta'),
        codigoU: this.selectedItem.codigo,
        mail: this.selectedItem.email,
        nombre: this.selectedItem.nombre,
      })
        .then((response) => {
          if (response.status === 200) {
            this.init();
          }
        });
      this.dialogMod = false;
    },
    editItem(item) {
      this.dialogMod = true;
      this.selectedItem = item;
    },
    deleteItem(item) {
      this.dialogRemove = true;
      this.selectedItem = item;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
